import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopilotRecipient } from '../../../_interfaces/document';
import {
  displayName,
  formatAddressBullets,
  isManualRecipient,
} from './recipient.helpers';

@Component({
  selector: 'app-recipient-details',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (isManualRecipient(recipient)) {
      <p class="body-medium text-on-surface break-words whitespace-pre-line m-0">{{ recipient.content }}</p>
    } @else {
      <div class="flex flex-col gap-2">
        <div class="flex flex-col gap-0.5">
          <p
            class="label-large-prominent font-bold text-primary m-0"
            [class.truncate]="truncateName">{{ displayName(recipient) }}</p>
          @if (recipient.recipient_type) {
            <p class="label-medium-prominent text-on-surface-variant m-0">{{ recipient.recipient_type }}</p>
          }
        </div>
        @if (formatAddressBullets(recipient)) {
          <p class="label-medium text-on-surface-variant m-0">{{ formatAddressBullets(recipient) }}</p>
        }
      </div>
    }
  `,
})
export class RecipientDetailsComponent {
  @Input({ required: true }) recipient!: CopilotRecipient;
  @Input() truncateName = false;

  displayName = displayName;
  formatAddressBullets = formatAddressBullets;
  isManualRecipient = isManualRecipient;
}
